import Button from '@mui/material/Button';
import GitHubIcon from '@mui/icons-material/GitHub';
import { useUserLanguage, useTranslate } from '@mui/docs/i18n';
import { jsx as _jsx } from "react/jsx-runtime";
var LOCALES = {
  zh: 'zh-CN',
  pt: 'pt-BR',
  es: 'es-ES'
};
export default function EditPage(props) {
  var sourceLocation = props.sourceLocation;
  var t = useTranslate();
  var userLanguage = useUserLanguage();
  if (!sourceLocation) {
    // An empty div such that the footer layout stays unchanged.
    return /*#__PURE__*/_jsx("div", {});
  }
  var CROWDIN_ROOT_URL = 'https://crowdin.com/project/material-ui-docs/';
  var crowdInLocale = LOCALES[userLanguage] || userLanguage;
  var crowdInPath = sourceLocation.substring(0, sourceLocation.lastIndexOf('/'));
  return /*#__PURE__*/_jsx(Button, {
    component: "a",
    size: "small",
    variant: "text",
    color: "secondary",
    startIcon: /*#__PURE__*/_jsx(GitHubIcon, {
      sx: {
        mr: 0.5
      }
    }),
    href: userLanguage === 'en' ? "".concat(process.env.SOURCE_CODE_REPO, "/edit/").concat(process.env.SOURCE_GITHUB_BRANCH).concat(sourceLocation) : "".concat(CROWDIN_ROOT_URL).concat(crowdInLocale, "#/").concat(process.env.SOURCE_CODE_ROOT_URL.replace('https://github.com/mui/', '').replace('/blob/', '%20%2F%20')).concat(crowdInPath),
    target: "_blank",
    rel: "noopener nofollow",
    "data-ga-event-category": userLanguage === 'en' ? undefined : 'l10n',
    "data-ga-event-action": userLanguage === 'en' ? undefined : 'edit-button',
    "data-ga-event-label": userLanguage === 'en' ? undefined : userLanguage,
    children: t('editPage')
  });
}
false ? void 0 : void 0;